<app-dialog
  [visible]="visible"
  [width]="'420px'"
  [closable]="true"
  [overlayZIndex]="100000"
  (visibleChange)="visibleChange.emit($event)">
  <ng-container ngProjectAs="header">
    <span class="modal-title">{{ "UPLOADED_GEO_IMAGES.COORDINATE_MODAL_TITLE" | translate }}</span>
  </ng-container>
  <ng-container ngProjectAs="content">
    <div class="coordinate-form">
      <app-input
        type="number"
        [label]="'UPLOADED_GEO_IMAGES.COORDINATE_MODAL_LATITUDE' | translate"
        [(ngModel)]="latitude"
        [min]="-90"
        [maxFractionDigits]="10"
        step="0.000001"></app-input>
      <app-input
        type="number"
        [label]="'UPLOADED_GEO_IMAGES.COORDINATE_MODAL_LONGITUDE' | translate"
        [(ngModel)]="longitude"
        [min]="-180"
        [maxFractionDigits]="10"
        step="0.000001"></app-input>
      <div
        class="coordinate-form__error"
        *ngIf="showError && !isValid">
        {{ "UPLOADED_GEO_IMAGES.COORDINATE_MODAL_ERROR_INVALID" | translate }}
      </div>
    </div>
  </ng-container>
  <ng-container ngProjectAs="footer">
    <app-secondary-button
      [title]="'UPLOADED_GEO_IMAGES.COORDINATE_MODAL_CANCEL' | translate"
      (action)="handleCancel()"></app-secondary-button>
    <app-primary-button
      [title]="'UPLOADED_GEO_IMAGES.COORDINATE_MODAL_CONFIRM' | translate"
      (action)="handleConfirm()"></app-primary-button>
  </ng-container>
</app-dialog>
